import { render, staticRenderFns } from "./StatusCounter.vue?vue&type=template&id=4d5af947&"
import script from "./StatusCounter.vue?vue&type=script&lang=js&"
export * from "./StatusCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports